import $ from 'jquery';

$(() => {
  $('a.toggle_inner_content').click(function () {
    $($(this).attr('href')).slideToggle('fast');
    return false;
  });
});
